package com.veldekar.pages.spells

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.`data`.add
import com.varabyte.kobweb.core.`init`.InitRoute
import com.varabyte.kobweb.core.`init`.InitRouteContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.style.toModifier
import com.veldekar.components.layouts.PageLayout
import com.veldekar.components.layouts.PageLayoutData
import com.veldekar.components.srd.SpellCardContent
import com.veldekar.components.srd.spells.FireballDescription
import com.veldekar.components.srd.spells.FireballMetadata
import org.jetbrains.compose.web.css.cssRem

@InitRoute
public fun initFireballPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(
        title = "Fireball",
        ogTitle = "Fireball",
        ogDescription = "A favorite of Tuesday, Dirk, and Annette. You may not even see Tuesday (he’s flying high above you) and your spell resistance is no match for his metamagics.",
        ogImage = "images/mushroomCloud.webp",
        ogImageWidth = 1_315,
        ogImageHeight = 1_068,
        ogImageAlt = "Illustration of the spell Fireball",
        includeSrdAttribution = true,
        isModal = true,
        showModalCard = false
    ))
}

@Page(routeOverride = "/spell-fireball")
@Composable
public fun FireballPage() {
    val ctx = rememberPageContext()
    PageLayout(ctx) {
        Column(Modifier.fillMaxWidth().padding(2.cssRem).gap(1.cssRem)) {
            SpellCardContent(
                name = "Fireball",
                subtitle = "3rd-level Evocation",
                veldekar = "A favorite of Tuesday, Dirk, and Annette. You may not even see Tuesday (he’s flying high above you) and your spell resistance is no match for his metamagics.",
                image = "images/mushroomCloud.webp",
                imageWidth = 1_315,
                imageHeight = 1_068,
                headerExtra = {
                    Row(Modifier.cursor(Cursor.Pointer).onClick { ctx.router.navigateTo("/spells") }, verticalAlignment = Alignment.CenterVertically) {
                        CloseIcon(Modifier.fontSize(1.5.cssRem))
                    }
                }
                ,
                metadata = { FireballMetadata() },
                content = { FireballDescription() }
            )
        }
    }
}
